import _definePage_default_0 from '/app/src/pages/[...error].vue?definePage&vue'
import { _mergeRouteRecord } from 'unplugin-vue-router/runtime'
import _definePage_default_2 from '/app/src/pages/access-control.vue?definePage&vue'
import _definePage_default_3 from '/app/src/pages/apps/email/index.vue?definePage&vue'
import _definePage_default_4 from '/app/src/pages/forgot-password.vue?definePage&vue'
import _definePage_default_5 from '/app/src/pages/login.vue?definePage&vue'
import _definePage_default_6 from '/app/src/pages/not-authorized.vue?definePage&vue'
import _definePage_default_7 from '/app/src/pages/pages/user-profile/[tab].vue?definePage&vue'
import _definePage_default_8 from '/app/src/pages/register.vue?definePage&vue'

export const routes = [
  _mergeRouteRecord(
  {
    path: '/:error(.*)',
    name: '$error',
    component: () => import('/app/src/pages/[...error].vue'),
    /* no children */
  },
  _definePage_default_0
  ),
  _mergeRouteRecord(
  {
    path: '/access-control',
    name: 'access-control',
    component: () => import('/app/src/pages/access-control.vue'),
    /* no children */
  },
  _definePage_default_2
  ),
  {
    path: '/apps',
    /* internal name: 'apps' */
    /* no component */
    children: [
      {
        path: 'email',
        /* internal name: 'apps-email' */
        /* no component */
        children: [
  _mergeRouteRecord(
          {
            path: '',
            name: 'apps-email',
            component: () => import('/app/src/pages/apps/email/index.vue'),
            /* no children */
          },
  _definePage_default_3
  )
        ],
      },
      {
        path: 'openweather',
        /* internal name: 'apps-openweather' */
        /* no component */
        children: [
          {
            path: 'dashboard',
            name: 'apps-openweather-dashboard',
            component: () => import('/app/src/pages/apps/openweather/dashboard.vue'),
            /* no children */
          }
        ],
      },
      {
        path: 'permissions',
        /* internal name: 'apps-permissions' */
        /* no component */
        children: [
          {
            path: '',
            name: 'apps-permissions',
            component: () => import('/app/src/pages/apps/permissions/index.vue'),
            /* no children */
          }
        ],
      },
      {
        path: 'roles',
        /* internal name: 'apps-roles' */
        /* no component */
        children: [
          {
            path: '',
            name: 'apps-roles',
            component: () => import('/app/src/pages/apps/roles/index.vue'),
            /* no children */
          }
        ],
      },
      {
        path: 'sharepoint',
        /* internal name: 'apps-sharepoint' */
        /* no component */
        children: [
          {
            path: 'dashboard',
            name: 'apps-sharepoint-dashboard',
            component: () => import('/app/src/pages/apps/sharepoint/dashboard.vue'),
            /* no children */
          },
          {
            path: 'SharePointTasks',
            name: 'apps-sharepoint-share-point-tasks',
            component: () => import('/app/src/pages/apps/sharepoint/SharePointTasks.vue'),
            /* no children */
          }
        ],
      },
      {
        path: 'spot',
        /* internal name: 'apps-spot' */
        /* no component */
        children: [
          {
            path: 'dashboard',
            name: 'apps-spot-dashboard',
            component: () => import('/app/src/pages/apps/spot/dashboard.vue'),
            /* no children */
          }
        ],
      },
      {
        path: 'starlink',
        /* internal name: 'apps-starlink' */
        /* no component */
        children: [
          {
            path: 'dashboard',
            name: 'apps-starlink-dashboard',
            component: () => import('/app/src/pages/apps/starlink/dashboard.vue'),
            /* no children */
          },
          {
            path: 'IntegratedDashboard',
            name: 'apps-starlink-integrated-dashboard',
            component: () => import('/app/src/pages/apps/starlink/IntegratedDashboard.vue'),
            /* no children */
          }
        ],
      },
      {
        path: 'user',
        /* internal name: 'apps-user' */
        /* no component */
        children: [
          {
            path: 'dashboard',
            name: 'apps-user-dashboard',
            component: () => import('/app/src/pages/apps/user/dashboard.vue'),
            /* no children */
          },
          {
            path: 'list',
            /* internal name: 'apps-user-list' */
            /* no component */
            children: [
              {
                path: '',
                name: 'apps-user-list',
                component: () => import('/app/src/pages/apps/user/list/index.vue'),
                /* no children */
              }
            ],
          }
        ],
      }
    ],
  },
  {
    path: '/apps/email/:filter',
    name: 'apps-email-filter',
    component: () => import('/src/pages/apps/email/index.vue'),
    /* no children */
  },
  {
    path: '/apps/email/:label',
    name: 'apps-email-label',
    component: () => import('/src/pages/apps/email/index.vue'),
    /* no children */
  },
  {
    path: '/dashboards',
    /* internal name: 'dashboards' */
    /* no component */
    children: [
      {
        path: 'home',
        name: 'dashboards-home',
        component: () => import('/app/src/pages/dashboards/home.vue'),
        /* no children */
      }
    ],
  },
  _mergeRouteRecord(
  {
    path: '/forgot-password',
    name: 'forgot-password',
    component: () => import('/app/src/pages/forgot-password.vue'),
    /* no children */
  },
  _definePage_default_4
  ),
  _mergeRouteRecord(
  {
    path: '/login',
    name: 'login',
    component: () => import('/app/src/pages/login.vue'),
    /* no children */
  },
  _definePage_default_5
  ),
  _mergeRouteRecord(
  {
    path: '/not-authorized',
    name: 'not-authorized',
    component: () => import('/app/src/pages/not-authorized.vue'),
    /* no children */
  },
  _definePage_default_6
  ),
  {
    path: '/pages',
    /* internal name: 'pages' */
    /* no component */
    children: [
      {
        path: 'dialog-examples',
        /* internal name: 'pages-dialog-examples' */
        /* no component */
        children: [
          {
            path: '',
            name: 'pages-dialog-examples',
            component: () => import('/app/src/pages/pages/dialog-examples/index.vue'),
            /* no children */
          }
        ],
      },
      {
        path: 'user-profile',
        /* internal name: 'pages-user-profile' */
        /* no component */
        children: [
  _mergeRouteRecord(
          {
            path: ':tab',
            name: 'pages-user-profile-tab',
            component: () => import('/app/src/pages/pages/user-profile/[tab].vue'),
            /* no children */
          },
  _definePage_default_7
  )
        ],
      }
    ],
  },
  _mergeRouteRecord(
  {
    path: '/register',
    name: 'register',
    component: () => import('/app/src/pages/register.vue'),
    /* no children */
  },
  _definePage_default_8
  )
]
